import React, { useState, useEffect } from 'react';
import { Col, Text, Scroll, useDynamicResponsiveValue, Row, Img } from 'react-quick-style-components';
import { useNavFunc, Reset } from 'navigation';
import { IScreen } from 'type';
import { ASSETS, COLOR, fSize, bodyTextSize, ICON, SCREEN_NAME } from 'const';
import { Image, StyleSheet } from 'react-native';
import { Footer, Header } from 'components';
import * as Animatable from 'react-native-animatable';
import GlobalEvent from 'js-events-listener';
import Store from 'store';
import { VarHelper } from 'helpers';

const SPACE_UNIT = 20;
const BOX_SIZE = 200;

const Animatebox = ({ item }) => {
  const [show, setShow] = useState(false);
  return (
    <Col
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      onPress={item.onPress}
      marginHorizontal={SPACE_UNIT / 2} marginBottom={SPACE_UNIT} overflow="hidden"
      height={BOX_SIZE} width={BOX_SIZE} alignSelf="center" backgroundColor={COLOR.MAIN} middle
    >
      <Img source={item.logo} height={item.size} width={item.size} display={show ? 'none' : 'flex'} resizeMode="contain" />
      {show &&
        <Animatable.View
          style={{ padding: 10, ...StyleSheet.absoluteFillObject, backgroundColor: 'rgba(0,0,0,0.7)', justifyContent: 'center' }}
          animation="fadeIn" duration={300} useNativeDriver
        >
          <Text color={COLOR.WHITE} textAlign="center" fontSize={12}>{item.text}</Text>
        </Animatable.View>
      }
    </Col>
  )
}


const Home: IScreen = () => {
  
  const { route, navigate } = useNavFunc();
  const rV = useDynamicResponsiveValue()
  const bannerHeight = rV({ xs: 150, lg: 200, xxxl: 262 });
  
  const [{ user, firebaseUser, token }] = Store.User.createStore();
  const [{ listPages }, iApi] = Store.Info.createStore();

  useEffect(() => {
    iApi.getListPages();
  }, []);

  const pageData = listPages.find(val => val.Title === 'Home');
  const pageDataImages = VarHelper.imgApiStringifyGetAll(pageData?.Images);

  console.log(pageData);

  const BOXES = [{
    logo: ASSETS.LOGO, size: 150, text: pageData?.['Text 1'], onPress: () => {
      GlobalEvent.emit('CHANGE_LOGO', { img: ASSETS.LOGO, ratio: 215/114, name: 'GroupPortal' });
      navigate(SCREEN_NAME.AccountSummary);
    },
    }, {
    logo: ASSETS.WHISKY_LOGO, size: 120, text: pageData?.['Text 2'], onPress: () => {
      // GlobalEvent.emit('CHANGE_LOGO', { img: ASSETS.NEWLOGO, ratio: 519 / 445, name: 'Vintage Whisky Club' });
      // navigate(SCREEN_NAME.Dashboard);
      window.open('https://vintagewhiskyclub.com/', '_blank');
    },
  }, {
    logo: ASSETS.LOGO3, size: 120, text: pageData?.['Text 3'], onPress: () => {
      // GlobalEvent.emit('CHANGE_LOGO', { img: ASSETS.LOGO3, ratio: 159.8 / 139.41, name: 'Vintage Bottlers' });
      // navigate(SCREEN_NAME.Dashboard);
      window.open('https://vintagebottlersltd.com', '_blank');
    },
  }, {
    logo: ASSETS.LOGO4, size: 120, text: pageData?.['Text 4'], onPress: () => {
      // GlobalEvent.emit('CHANGE_LOGO', { img: ASSETS.LOGO4, ratio: 165 / 140, name: 'Vintage Auction House' });
      // navigate(SCREEN_NAME.Dashboard);
      // window.open('http://vintageauctionhouse.com', '_blank');
    },
  }];

  if (!firebaseUser || !firebaseUser.email) return (
    <Reset to={SCREEN_NAME.Login} timeout={0} />
  )

  return (
    <Col flex1 backgroundColor={COLOR.BG}>
      <Header />
      <Scroll flex1 >
        <Col middle height={bannerHeight}>
          <Image source={pageDataImages.length > 0 ? { uri: pageDataImages[0] } : ASSETS.BANNER_ACCOUNT} style={[{ height: bannerHeight }, styles.banner]} />
          <Col zIndex99 center>
            <Text fontSize={fSize(rV, 52)} colorWhite>Home</Text>
            <Col alignSelf="center">
              <ICON.IcPattern />
            </Col>
          </Col>
        </Col>
        <Col>
          <Text
            marginVertical={rV({ xs: 20, lg: 50 })} marginHorizontal={rV({ xs: 30, md: 120, lg: 180 })}
            body1 textAlign="center"
          >
            {pageData?.Description}
          </Text>
          <Col alignItems="center" justifyContent="center">
            <Row xs='50%' md="50%" lg='1:.' marginHorizontal={rV({ xs: 20, lg: 100 })}>
              {BOXES.map((item, i) => (
                <Animatebox key={'gray-' + i} item={item} />
              ))}
            </Row>
          </Col>
        </Col>
      </Scroll>
      <Footer />
    </Col>
  );
};

Home.routeInfo = {
  title: 'Home',
  path: '/',
};

const styles = StyleSheet.create({
  banner: {
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  },
})

export default Home;